import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/lib/media";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { CalendarDays, MapPin, Clock } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/events").then((res) => setEvents(res.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="events-page">
      <SEO
        title="Upcoming Events"
        description="Free physiotherapy camps, workshops and awareness drives by PhysioAbhi Healthcare Foundation across Bengaluru."
        path="/events"
      />
      <PageHeader
        eyebrow="Upcoming Events"
        title="Join us on the ground."
        subtitle="Free camps, workshops and awareness drives happening across Bengaluru — updated regularly by our team."
      />
      <section className="px-5 md:px-10 py-16">
        <div className="max-w-4xl mx-auto space-y-6">
          {loading && <p data-testid="events-loading" className="text-muted-foreground">Loading events…</p>}
          {!loading && events.length === 0 && (
            <p data-testid="events-empty" className="text-muted-foreground">No upcoming events right now. Check back soon.</p>
          )}
          {events.map((e, i) => (
            <Reveal key={e.id} delay={i * 0.08}>
              <div data-testid={`event-card-${e.id}`} className="grid grid-cols-1 md:grid-cols-[220px_1fr] border border-border hover:border-accent transition-colors">
                {e.image_url && (
                  <div className="aspect-[4/3] md:aspect-auto md:h-full overflow-hidden">
                    <img src={resolveImageUrl(e.image_url)} alt={e.title} className="w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-6 md:p-8">
                  <h3 className="font-heading text-xl md:text-2xl mb-3">{e.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-4">{e.description}</p>
                  <div className="flex flex-wrap gap-4 text-sm text-foreground/70">
                    <span className="flex items-center gap-1.5"><CalendarDays className="h-4 w-4 text-accent" />{e.event_date}</span>
                    {e.event_time && <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-accent" />{e.event_time}</span>}
                    {e.location && <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4 text-accent" />{e.location}</span>}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
